import { notification } from 'ant-design-vue';

function objectToFormData(obj, form = new FormData(), namespace = '') {
    for (let property in obj) {
        if (!obj.hasOwnProperty(property) || obj[property] === undefined || obj[property] === null) {
            continue;
        }

        const formKey = namespace ? `${namespace}[${property}]` : property;
        const value = obj[property];

        if (value instanceof Date) {
            form.append(formKey, value.toISOString());
        } else if (value instanceof File || value instanceof Blob) {
            form.append(formKey, value);
        } else if (Array.isArray(value)) {
            value.forEach((element, index) => {
                objectToFormData(element, form, `${formKey}[${index}]`);
            });
        } else if (typeof value === 'object') {
            objectToFormData(value, form, formKey);
        } else {
            form.append(formKey, value);
        }
    }

    return form;
}

function toBase64(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(file);
    });
}

function generateMediaUrl(path) {
    const baseUrl = process.env.VUE_APP_BASE_MEDIA

    return baseUrl + '/' + path
}

/**
 * @param {string} description - Pesan Alert
 * @param {'success' | 'error' | 'warning' | 'info'} type - Tipe Alert
 * @param {string} title - Judul Alert
 */
function showAlert(description, type, title = '') {
    notification[type]({
        message: title,
        description,
    })
}

function useDebounce(fn, delay) {
    let timer
    return function (...args) {
        clearTimeout(timer)
        timer = setTimeout(() => {
            fn.apply(this, args)
        }, delay)
    }
}

function getUrlLayanan(layanan) {
    const token = localStorage.getItem('token')
    if (token && layanan.is_sso) {
        return `${layanan.sso_redirect_uri}?token=${token}`
    }

    return layanan.link
}

export {
    objectToFormData,
    toBase64,
    generateMediaUrl,
    showAlert,
    useDebounce,
    getUrlLayanan,
}